export interface TokenInfo {
    exp: number;
    globusTenant?: string;
    email: string;
}

/**
 * Parses a JWT token and extracts its payload
 * @param token - JWT token string
 * @returns Parsed token payload
 */
export function parseJwtToken(token: string): TokenInfo {
    try {
        const payload = token.split('.')[1];

        return JSON.parse(atob(payload));
    } catch (error) {
        throw new Error('Invalid JWT token format');
    }
}
